module.exports = __webpack_public_path__ + "img/card-lines.1aaaa296.svg";